import Vue from 'vue'
import Vuex from 'vuex'
import tenant from './modules/tenant'
import auth from './modules/auth'
import spinner from './modules/spinner'
import errors from './modules/errors'

Vue.use(Vuex)

const prod = process.env.NODE_ENV === 'production'

export default new Vuex.Store({
    modules: {
        tenant,
        auth,
        spinner,
        errors
    },
    strict: !prod,
    plugins: []
})
